<template>
  <div class="address_bg_style">
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <van-address-edit
      :area-list="areaList"
      show-delete
      show-set-default
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
      @delete="onDelete"
      @change-detail="onChangeDetail"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { areaList } from "@vant/area-data";
import { Toast } from "vant";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return { areaList, searchResult: [] };
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.push({
        path: "/address",
      });
    },
    onSave() {
      Toast("save");
    },
    onDelete() {
      Toast("delete");
    },
    onChangeDetail(val) {
      if (val) {
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.address_bg_style {
  background: #f5f6f8;
}
</style>